import { stateName } from '../coverage/states.js';
import { stateAbbrToFips } from '../coverage/states.js';
export const EXPLORE_LEVELS = ['city', 'county', 'zip', 'state'];
const num = (v) => Number(v ?? 0) || 0;
const titleCase = (s) => s.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
function placeName(r, names) {
    switch (r.level) {
        case 'city': {
            const n = names.cityNames[r.id] ?? r.top_city ?? r.id;
            return `${n.replace(/ (city|town|village|borough|municipality)$/i, '')}, ${r.st}`;
        }
        case 'county':
            return `${names.countyNames[r.id] ?? r.id}, ${r.st}`;
        case 'zip':
            return r.top_city ? `${r.id} (${titleCase(r.top_city)}, ${r.st})` : `${r.id}, ${r.st}`;
        default: {
            const fips = stateAbbrToFips(r.id);
            return (fips && stateName(fips)) ?? r.id;
        }
    }
}
export function buildExplore(rows, opts) {
    const places = [];
    const shards = {};
    for (const r of rows) {
        const level = r.level;
        const ref = {
            level,
            id: r.id,
            name: placeName(r, opts),
            state: r.st,
            n: num(r.n),
        };
        places.push(ref);
        const tagYears = {};
        for (const t of r.tag_years ?? []) {
            const list = tagYears[t.tag] ?? [];
            list.push([num(t.y), num(t.n)]);
            tagYears[t.tag] = list;
        }
        for (const list of Object.values(tagYears))
            list.sort((a, b) => a[0] - b[0]);
        const key = `${level}/${r.st}`;
        const shard = shards[key] ?? {};
        shard[r.id] = {
            ...ref,
            years: (r.years ?? [])
                .map((y) => [num(y.y), num(y.n)])
                .sort((a, b) => a[0] - b[0]),
            tags: (r.tags ?? []).map((t) => [t.tag, num(t.n)]),
            tag_years: tagYears,
        };
        shards[key] = shard;
    }
    return { index: { generated_at: opts.generatedAt, places }, shards };
}
/** Place picker search: match on name or id, busiest first. */
export function searchPlaces(places, level, q, limit = 20) {
    const needle = q.trim().toLowerCase();
    return places
        .filter((p) => p.level === level &&
        (!needle || p.name.toLowerCase().includes(needle) || p.id.startsWith(needle)))
        .sort((a, b) => b.n - a.n)
        .slice(0, limit);
}
/** All permits over the last 10 years, or one tag over the last 5. */
export function exploreView(place, tag, thisYear) {
    const span = tag ? 5 : 10;
    const source = tag ? (place.tag_years[tag] ?? []) : place.years;
    const byYear = new Map(source);
    const series = Array.from({ length: span }, (_, i) => {
        const year = thisYear - span + 1 + i;
        return { year, n: byYear.get(year) ?? 0 };
    });
    const topTags = place.tags
        .slice(0, 12)
        .map(([t, n]) => ({ tag: t, n, share: place.n > 0 ? n / place.n : 0 }));
    return { series, topTags };
}
//# sourceMappingURL=explore.js.map